import { Alert, Collapse } from 'antd'
import { useCurrentUser, useJurisdictionProperties } from 'api'
import Container from 'components/Container'
import { FormItem, Select } from 'formik-antd'
import { useLocalization } from 'localization'
import Skeleton from './skeleton'
import { FC, useMemo } from 'react'
import { useFormikContext } from 'formik'
import { IWalletFormValues } from './types'

interface IWalletProperties {
	isEdit?: boolean
}

const WalletProperties: FC<IWalletProperties> = ({ isEdit = false }) => {
	const { t } = useLocalization()
	const { data: user } = useCurrentUser()
	const { values, initialValues } = useFormikContext<IWalletFormValues>()
	const { walletProperties = [], isLoading, isFetched } = useJurisdictionProperties(user?.jurisdiction)

	if (walletProperties.length === 0) return null

	const shouldShowWarning = useMemo(
		() =>
			walletProperties.some(({ key }) =>
				isEdit ? values.properties?.[key] !== initialValues.properties?.[key] : false
			),
		[walletProperties, values, initialValues, isEdit]
	)

	return (
		<Collapse>
			<Collapse.Panel header={t('terms.properties')} key="1">
				<Container display="flex" flexDirection="column" space="sm" spaceDirection="vertical">
					{isLoading && !isFetched ? (
						<Skeleton />
					) : (
						<Container spaceDirection="vertical" space="sm">
							{shouldShowWarning && <Alert type="info" message={t('wallets.edit.propertyChangeWarning')} />}
							<Container>
								{walletProperties.map(({ title, key, options }) => (
									<FormItem key={key} name={`properties.${key}`} label={title}>
										<Select name={`properties.${key}`} options={options} placeholder={t('placeholders.property')} />
									</FormItem>
								))}
							</Container>
						</Container>
					)}
				</Container>
			</Collapse.Panel>
		</Collapse>
	)
}

export default WalletProperties
